import { borderRadius, colors, space } from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";
import styled, { css } from "styled-components/macro";

interface CheckBoxWrapperProps {
  error?: boolean;
}

const OptionStyles = css`
  label {
    display: flex;
    align-items: center;
  }

  input {
    position: relative;

    cursor: pointer;
    appearance: none;
    flex: 0 0 auto;

    height: 18px;
    width: 18px;

    /* visually center align input with text */
    margin: 1px ${space.xs} 0 0;

    background-color: ${colors.white};

    flex-shrink: 0;

    ${hoverFocus.defaultFocus}

    &:checked {
      background-color: ${colors.blue};
      border-color: ${colors.blue};
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
      background-color: ${colors.grey4};
    }
  }
`;

export const CheckBoxWrapper = styled.div<CheckBoxWrapperProps>`
  ${OptionStyles};

  input {
    border-radius: ${borderRadius.xs};

    background-size: 10px;
    background-repeat: no-repeat;
    background-position: center;

    &:checked {
      background-image: url("data:image/svg+xml,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.75.25a.85.85 0 00-1.2 0L3.36 5.44a.28.28 0 01-.4 0L1.45 3.93a.85.85 0 00-1.2 1.2l2.31 2.3c.33.34.87.34 1.2 0l6-5.98a.85.85 0 000-1.2z' fill='%23fff'/%3E%3C/svg%3E");
    }

    ${({ error }) =>
      error &&
      css`
        box-shadow: 0 0 0 2px ${colors.red};
      `}
  }
`;

export interface RadioWrapperProps extends CheckBoxWrapperProps {
  size?: "lg" | "default";
  disabled?: boolean;
}

export const RadioWrapper = styled.div<RadioWrapperProps>`
  ${OptionStyles};

  ${({ disabled }) => disabled && "opacity: 0.6; pointer-events: none;"}

  input {
    border-radius: 50%;
    border: 1px solid ${colors.grey5};

    ${({ size }) =>
      size === "lg" &&
      css`
        margin-right: ${space.l};
      `}

    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: 10px;
      height: 10px;

      border-radius: 50%;
      background-color: ${colors.white};
    }

    &:checked {
      &::after {
        content: "";
      }
    }

    ${({ error }) =>
      error &&
      css`
        box-shadow: 0 0 0 2px ${colors.red};
      `}
  }
`;
interface StyledDraggableWrapperProps {
  childrenLength: number;
}
export const StyledDraggableWrapper = styled.div<StyledDraggableWrapperProps>`
  ${({ childrenLength }) =>
    css`
      min-height: ${childrenLength * 51 + (childrenLength - 1) * 16}px;
    `}
`;
